import TamanioDelete from './TamanioDelete'
export {TamanioDelete}
export default TamanioDelete
